module.exports = __webpack_public_path__ + "fonts/varelaround-regular-webfont.569580a5.woff2";